import { render, staticRenderFns } from "./VersusOverview.vue?vue&type=template&id=a717a0aa&scoped=true&"
import script from "./VersusOverview.vue?vue&type=script&lang=js&"
export * from "./VersusOverview.vue?vue&type=script&lang=js&"
import style0 from "./VersusOverview.vue?vue&type=style&index=0&id=a717a0aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a717a0aa",
  null
  
)

export default component.exports